import axios from '@axios'

export default {
  getWithdrawals(page, field) {
    return axios.post(`platform/withdrawals/list?page=${page}`, field)
  },
  validateWithdrawal(id) {
    return axios.post(`platform/withdrawals/validate/${id}`)
  },
  getWithdrawal(id) {
    return axios.get(`platform/withdrawals/${id}`)
  },
  verifyWithdrawalStatus(id) {
    return axios.get(`platform/withdrawals/verify-status/${id}`)
  },
}
